<template>
  <div>
    <table ref="table" class="table">
      <thead>
        <tr>
          <th
            v-for="(tableHeader, i) in headers"
            :key="i"
            :class="[
              {
                'head--spacing': headSpacing
              }
            ]"
          >
            {{ tableHeader.label }}
          </th>
        </tr>
      </thead>
      <tbody>
        <slot />
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "Datatable",
  components: {},
  data() {
    return {
      cells: []
    };
  },
  props: {
    headers: {
      type: Array,
      default: () => []
    },
    headSpacing: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
table {
  max-width: 100%;
  width: 100% !important;
  thead {
    color: $gray-900;
    font-family: "Gotham";
    font-weight: 500;
    font-size: $font-size-xs;
    th {
      font-family: "Gotham";
      text-transform: none !important;

      &.head--spacing {
        padding-bottom: 36px;
      }
    }
  }
  tbody {
    tr {
      td {
        font-family: "Gotham Book";
        font-size: $font-size-xs;
        .actions-wrapper {
          display: flex;
          button {
            border: none;
            border-radius: 5px;
            cursor: pointer;
            display: block;
            height: 30px;
            outline: none;
            transition: all 0.3s ease-in;
            width: 30px;
            &.edit-btn {
              background-color: #007bff;
              margin-right: 5px;
              &:hover {
                background-color: #0069d9;
              }
            }
            &.delete-btn {
              background-color: #dc3545;
              color: $white;
              &:hover {
                background-color: #c82333;
              }
            }
          }
        }
        span {
          font-family: "Gotham Book";
        }
      }
    }
  }
}
</style>
